import api from "~/store/api"
import serialize from "~/store/serialize"

export const listClients = (data) => {
  return api
    .get("/clients", data)
    .then((res) => serialize("client", res.data.data))
}

export const listUserClients = (data) => {
  return api
    .get("/clients?users_only=true", data)
    .then((res) => serialize("client", res.data.data))
}

export const createClient = (data) => {
  return api.post("/clients", data).then((res) => res.data)
}

export const checkAccessCode = (data) => {
  return api.post("/check_access_code", data).then((res) => res.data)
}

export const setAccessCode = (data, id) => {
  return api.post(`/access_codes/${id}`, data).then((res) => res.data)
}

export const updateClient = (data, id) => {
  return api.put(`/clients/${id}`, data).then((res) => res.data)
}

export const removeClient = (id) => {
  return api.delete(`/clients/${id}`).then((res) => res.data)
}
export const createClientApiKey = (data, id) => {
  return api.post(`/clients/${id}/api_key`, data).then((res) => res.data)
}
export const updateClientKeys = (id, api_key_id, data) => {
  return api
    .put(`/clients/${id}/api_keys/${api_key_id}`, data)
    .then((res) => res.data)
}
export const removeClientKey = (id, api_key_id) => {
  return api
    .delete(`/clients/${id}/api_key/${api_key_id}`)
    .then((res) => res.data)
}

export const listPublishedCourses = () => {
  return api
    .get("/published_courses")
    .then((res) => serialize("course", res.data.data))
}

export const addClientCourses = (data, id) => {
  return api.post(`/clients/${id}/courses`, data).then((res) => res.data)
}
